/* ─────────────────────────────────────────────
   SHARED GSAP UTILITIES
───────────────────────────────────────────── */
import React from 'react';
import { gsap } from 'gsap';

/** Vanilla char splitter (replaces GSAP SplitText plugin) */
export function splitIntoChars(el) {
  const text = el.textContent;
  el.innerHTML = '';
  const chars = [];
  for (const char of text) {
    const span = document.createElement('span');
    span.textContent = char === ' ' ? '\u00A0' : char;
    span.style.display = 'inline-block';
    el.appendChild(span);
    chars.push(span);
  }
  return chars;
}

/** Count-up animation — correct gsap.fromTo(target, from, to) signature */
export function animateCounter(el, end, prefix = '', suffix = '') {
  const proxy = { val: 0 };
  gsap.fromTo(proxy, { val: 0 }, {
    val: end,
    duration: 2,
    ease: 'power2.out',
    onUpdate() { el.textContent = prefix + Math.round(proxy.val) + suffix; },
    scrollTrigger: { trigger: el, start: 'top 85%', once: true },
  });
}

/** Shared section style */
export const sectionStyle = {
  minHeight: '100vh',
  background: 'var(--black)',
  position: 'relative',
  overflow: 'hidden',
};

/** Section label component data */
export const Label = ({ n, text }) => (
  <div style={{ fontFamily: 'Space Mono', fontSize: '0.7rem', color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '1.5rem', opacity: 0.8 }}>
    {n} — {text}
  </div>
);

/** Thin divider with scrubbed reveal */
export const Divider = ({ color = 'var(--acid)' }) => (
  <div style={{ height: 1, background: '#111', position: 'relative', overflow: 'hidden' }}>
    <div className="divider-line" style={{ position: 'absolute', inset: 0, background: `linear-gradient(90deg,transparent,${color},transparent)`, transformOrigin: 'left', transform: 'scaleX(0)' }} />
  </div>
);
